import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsFieldLayoutsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-view',
	path: '/secure/admin/ViewFieldLayouts.jspa',
};
